import axios from 'axios';
import * as qs from 'qs';
import { ICrudDeleteAction, ICrudGetAction, ICrudPutAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';

import { defaultValue, IMessageContent } from 'app/shared/model/message-content.model';
import { ICrudGetListAction } from 'app/shared/model/list';
import { flattenKey } from 'app/shared/util/object-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_MESSAGECONTENT_LIST: 'messageContent/FETCH_MESSAGECONTENT_LIST',
  LOAD_MESSAGECONTENT_LIST: 'messageContent/LOAD_MESSAGECONTENT_LIST',
  FETCH_MESSAGECONTENT: 'messageContent/FETCH_MESSAGECONTENT',
  CREATE_MESSAGECONTENT: 'messageContent/CREATE_MESSAGECONTENT',
  UPDATE_MESSAGECONTENT: 'messageContent/UPDATE_MESSAGECONTENT',
  DELETE_MESSAGECONTENT: 'messageContent/DELETE_MESSAGECONTENT',
  RESET: 'messageContent/RESET'
};
// state
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IMessageContent>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0
};

export type MessageContentState = Readonly<typeof initialState>;

// Reducer

export default (state: MessageContentState = initialState, action): MessageContentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MESSAGECONTENT_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case REQUEST(ACTION_TYPES.LOAD_MESSAGECONTENT_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loadMore: true
      };
    case REQUEST(ACTION_TYPES.FETCH_MESSAGECONTENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_MESSAGECONTENT):
    case REQUEST(ACTION_TYPES.UPDATE_MESSAGECONTENT):
    case REQUEST(ACTION_TYPES.DELETE_MESSAGECONTENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_MESSAGECONTENT_LIST):
    case FAILURE(ACTION_TYPES.LOAD_MESSAGECONTENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MESSAGECONTENT):
    case FAILURE(ACTION_TYPES.CREATE_MESSAGECONTENT):
    case FAILURE(ACTION_TYPES.UPDATE_MESSAGECONTENT):
    case FAILURE(ACTION_TYPES.DELETE_MESSAGECONTENT):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_MESSAGECONTENT_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.LOAD_MESSAGECONTENT_LIST):
      return {
        ...state,
        loadMore: false,
        entities: state.entities.concat(action.payload.data),
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_MESSAGECONTENT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_MESSAGECONTENT):
    case SUCCESS(ACTION_TYPES.UPDATE_MESSAGECONTENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_MESSAGECONTENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/message-contents'; // 群发通知-已发通知

// Actions
// 已发通知列表
export const getEntities: ICrudGetListAction<IMessageContent> = (page, size, sort = 'createdAt,desc', searchForm) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_MESSAGECONTENT_LIST,
    payload: axios.get<IMessageContent>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
    }),
    meta: { transformUserName: true }
  };
};

export const loadEntities: ICrudGetListAction<IMessageContent> = (page, size, sort = 'createdAt,desc', searchForm) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.LOAD_MESSAGECONTENT_LIST,
    payload: axios.get<IMessageContent>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
    }),
    meta: { transformUserName: true }
  };
};
// 已发通知详情
export const getEntity: ICrudGetAction<IMessageContent> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_MESSAGECONTENT,
    payload: axios.get<IMessageContent>(requestUrl)
  };
};
// 创建已发通知
export const createEntity: ICrudPutAction<IMessageContent> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MESSAGECONTENT,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 更新已发通知
export const updateEntity: ICrudPutAction<IMessageContent> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MESSAGECONTENT,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 删除已发通知
export const deleteEntity: ICrudDeleteAction<IMessageContent> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MESSAGECONTENT,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
